import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import { IoIosArrowBack, IoIosArrowForward } from 'react-icons/io';
import ProductCard from '../../../components/ProductCard';
import { useTranslation } from 'react-i18next';
import { Product } from '../../../types/types';
import { instance } from '../../../api/axiosInstance';

interface PopularProductsProps {
  formatNumber: (number: number | bigint) => string;
  category: string;
}

const PopularProducts: React.FC<PopularProductsProps> = ({
  formatNumber,
  category,
}) => {
  const { t } = useTranslation();
  const [products, setProducts] = useState<Product[]>([]);
  const [isLoading, setIsLoading] = useState<boolean>(true); // 로딩 상태 추가
  const [isMobile, setIsMobile] = useState<boolean>(false);
  const sliderRef = useRef<Slider>(null);

  const handleResize = () => {
    setIsMobile(window.innerWidth <= 767);
  };

  useEffect(() => {
    handleResize();
    window.addEventListener('resize', handleResize);
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  useEffect(() => {
    const fetchProducts = async () => {
      setIsLoading(true); // 로딩 시작
      try {
        const response = await instance.get('/api/products/filter', {
          params: {
            category: category,
            count: 10,
          },
        });

        setProducts(response.data);
      } catch (error) {
        console.error('상품 데이터를 가져오는 중 오류 발생:', error);
      } finally {
        setIsLoading(false); // 로딩 종료
      }
    };

    fetchProducts();
  }, [category]);

  const settings_list = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: isMobile ? 2 : 5,
    slidesToScroll: isMobile ? 2 : 5,
    nextArrow: !isMobile ? <SampleNextArrow /> : undefined,
    prevArrow: !isMobile ? <SamplePrevArrow /> : undefined,
    centerPadding: '0px',
    centerMode: false,
  };

  function SampleNextArrow(props: any) {
    const { className, onClick } = props;
    return (
      <div className={`${className} slick-next`} onClick={onClick}>
        <div className="bg-white w-[40px] h-[40px] border border-black/10 hover:border-black/20 transition duration-300 rounded-full shadow-lg hover:shadow-xl flex items-center justify-center z-[9999]">
          <IoIosArrowForward className="text-[#191919]" size={18} />
        </div>
      </div>
    );
  }

  function SamplePrevArrow(props: any) {
    const { className, onClick } = props;
    return (
      <div className={`${className} slick-prev`} onClick={onClick} style={{ zIndex: '9' }}>
        <div className="bg-white w-[40px] h-[40px] border border-black/10 rounded-full hover:border-black/20 transition duration-300 shadow-lg hover:shadow-xl flex items-center justify-center z-[9999]">
          <IoIosArrowBack className="text-[#191919]" size={18} />
        </div>
      </div>
    );
  }

  return (
    <article className="w-full mx-auto mobile:py-0">
      <header className="text-left">
        <h1 className="text-3xl text-[#000] font-bold mobile:font-semibold mobile:text-lg">
          {t('product.popular', { category: t(`product.title.${category}`) })}
        </h1>
      </header>
      <div className="w-full mt-6 mobile:mt-4">
        {isLoading ? (
          <div className="flex justify-center items-center h-64">
            <span>Loading...</span> {/* 로딩 중일 때 표시할 요소 */}
          </div>
        ) : (
          <Slider ref={sliderRef} {...settings_list}>
            {products.map((product) => (
              <div className={'ml-[22px] mobile:ml-0 mobile:pr-[8px]'} key={product.id}>
                <ProductCard product={product} formatNumber={formatNumber} />
              </div>
            ))}
          </Slider>
        )}
      </div>
    </article>
  );
};

export default PopularProducts;
